module.exports = __webpack_public_path__ + "static/media/14touhoku.ddb51895.png";